import MaterialModal from '@mui/material/Modal';
import styled from 'styled-components';

export const StyledModal = styled(MaterialModal)`
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
`;
